<div class="container-fluid tw-flex tw-flex-col tw-gap-4">
  <div class="header">
    <div class="header-title">Investor Management</div>
    <div class="header-subtitle">Review and monitor investor details</div>
  </div>
  @if (!isPageLoading && !loadError && campaign && campaignSummary) {
    <div class="campaign-bar">
      <div class="campaign-tab">
        <div class="campaign-name">{{ campaign.name }}</div>
        <div class="campaign-status">
          {{ 'campaign.' + campaignStatus[campaign.campaignStatus] | translate }}
        </div>
      </div>
    </div>
    @if (
      campaign.campaignStatus === campaignStatus.ShareAllotment &&
      campaignSummary?.duedate == null &&
      campaignSummary?.successFee == null &&
      campaignSummary?.isAllInvestorsReviewStatusConfirmed !== true &&
      !finalSubmitted
    ) {
      <div class="due-date-banner due-date-banner-final">
        <div class="duedate-left">
          <div class="duedate-dot">
            <img src="/assets/img/icons/svgs/BlueDot.svg" alt="dot" />
          </div>
          <div class="duedate-content">
            <div class="duedate-title due-date-title-final">Finalising Ongoing</div>
            <div class="duedate-subtitle due-date-text-final">
              Finalizing details. The list will be available for review shortly
            </div>
          </div>
        </div>
      </div>
    }
    @if (
      campaign.campaignStatus === campaignStatus.ShareAllotment &&
      campaignSummary?.duedate != null &&
      campaignSummary?.isAnyInvestorNotApprovedOrConfirmed === true &&
      campaignSummary?.isAllInvestorsReviewStatusConfirmed !== true &&
      !finalSubmitted
    ) {
      <div
        class="due-date-banner"
        [ngClass]="isDueDateOverDue ? 'due-date-banner-over-due' : 'due-date-banner-in-progress'"
      >
        <div class="duedate-left">
          <div class="duedate-dot">
            <img
              [src]="
                isDueDateOverDue
                  ? '/assets/img/icons/svgs/RedDot.svg'
                  : '/assets/img/icons/svgs/OrangeDot.svg'
              "
              alt="dot"
            />
          </div>
          <div class="duedate-content">
            <div
              class="duedate-title"
              [ngClass]="
                isDueDateOverDue ? 'due-date-title-over-due' : 'due-date-title-in-progress'
              "
            >
              Review in Progress
            </div>
            <div
              class="duedate-subtitle"
              [ngClass]="isDueDateOverDue ? 'due-date-text-over-due' : 'due-date-text-in-progress'"
            >
              <span class="duedate-subtitle-left">
                <span class="duedate-subtitle-main">
                  {{ campaignSummary?.approvedInvestors || 0 }} of
                  {{ campaignSummary.paidInvestors || 0 }} investors approved
                </span>
                <span class="duedate-subtitle-due">
                  <span class="duedate-dot-separator">• </span>Due on
                  {{ campaignSummary?.duedate | date: 'dd-MM-yyyy' }}
                  @if (isDueDateOverDue) {
                    <span class="overdue-label overdue-label-inline">OVERDUE</span>
                  }
                </span>
              </span>
              @if (isDueDateOverDue) {
                <span class="overdue-label overdue-label-side">OVERDUE</span>
              }
            </div>
          </div>
        </div>
        <div class="duedate-progress">
          <div
            class="duedate-progress-percent"
            [ngClass]="isDueDateOverDue ? 'due-date-text-over-due' : 'due-date-text-in-progress'"
          >
            {{ approvedInvestorProgressPercent }}% Complete
          </div>
          <div
            class="duedate-progress-bar"
            role="progressbar"
            [attr.aria-valuenow]="approvedInvestorProgressPercent"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div
              class="duedate-progress-bar-fill"
              [style.width.%]="approvedInvestorProgressPercent"
              [style.backgroundColor]="isDueDateOverDue ? '#DC2626' : null"
            ></div>
          </div>
          <div
            class="duedate-progress-count"
            [ngClass]="isDueDateOverDue ? 'due-date-text-over-due' : 'due-date-text-in-progress'"
          >
            {{ campaignSummary?.approvedInvestors || 0 }}/{{ campaignSummary.paidInvestors || 0 }}
            approved
          </div>
        </div>
      </div>
    }
    @if (
      campaign.campaignStatus === campaignStatus.ShareAllotment &&
      campaignSummary?.duedate != null &&
      campaignSummary?.isAllInvestorsReviewStatusConfirmed !== true &&
      (finalSubmitted || campaignSummary?.isAnyInvestorNotApprovedOrConfirmed !== true)
    ) {
      <div
        class="due-date-banner"
        [ngClass]="
          finalSubmitted || campaignSummary?.isAnyInvestorNotApprovedOrConfirmed !== true
            ? 'due-date-banner-all-approved'
            : 'due-date-banner-final'
        "
      >
        <div class="duedate-left">
          <div class="duedate-dot">
            <img src="/assets/img/icons/svgs/GreenDot.svg" alt="dot" />
          </div>
          <div class="duedate-content">
            <div
              class="duedate-title"
              [ngClass]="
                finalSubmitted || campaignSummary?.isAnyInvestorNotApprovedOrConfirmed !== true
                  ? 'due-date-title-all-approved'
                  : 'due-date-title-final'
              "
            >
              {{ finalSubmitted ? 'Investor List Submitted' : 'All Investors Approved' }}
            </div>
            <div
              class="duedate-subtitle"
              [ngClass]="
                finalSubmitted || campaignSummary?.isAnyInvestorNotApprovedOrConfirmed !== true
                  ? 'due-date-text-all-approved'
                  : 'due-date-text-final'
              "
            >
              <span class="all-approved">
                {{
                  finalSubmitted
                    ? 'All investors have been reviewed and submitted'
                    : 'All investors have been approved and are ready for final submission'
                }}
              </span>
              <span class="m-all-approved">
                {{
                  finalSubmitted ? 'Investors reviewed and submitted' : 'Ready for final submission'
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="duedate-action">
          <button
            class="investorlist-submit"
            type="button"
            (click)="submitFinal()"
            [disabled]="finalSubmitted"
          >
            {{ finalSubmitted ? 'Submitted' : 'Submit' }}
          </button>
        </div>
      </div>
    }
    <div class="campaign-summary">
      <div class="campaign-summay-item">
        <img src="/assets/img/icons/svgs/TotalInvestment.svg" alt="total-investment" />
        <div class="campaign-summay-item-badge">
          <div class="campaign-summay-item-title">Total Investment</div>
          <div class="campaign-summay-item-value">
            {{ campaignSummary.totalInvestment | numberSuffix }}
          </div>
        </div>
      </div>
      <div class="campaign-summay-item">
        <img src="/assets/img/icons/svgs/PaidTotal.svg" alt="Paid Total" />
        <div class="campaign-summay-item-badge">
          <div class="campaign-summay-item-title">
            {{
              campaign.campaignStatus === campaignStatus.ShareAllotment ||
              campaign.campaignStatus === campaignStatus.Success
                ? 'Total Investors'
                : 'Paid / Total'
            }}
          </div>
          <div class="campaign-summay-item-value">
            {{
              campaign.campaignStatus === campaignStatus.ShareAllotment ||
              campaign.campaignStatus === campaignStatus.Success
                ? campaignSummary.paidInvestors
                : campaignSummary.paidInvestors + ' / ' + campaignSummary.totalInvestor
            }}
          </div>
        </div>
      </div>
      <div class="campaign-summay-item">
        <img src="/assets/img/icons/svgs/TotalShare.svg" alt="Total Shares" />
        <div class="campaign-summay-item-badge">
          <div class="campaign-summay-item-title">Total Shares</div>
          <div class="campaign-summay-item-value">{{ campaignSummary.totalShare }}</div>
          <div class="campaign-summay-item-subtitle">
            Base: {{ campaignSummary.baseShare }} | Free: {{ campaignSummary.bonusShare }}
          </div>
        </div>
      </div>
      <div class="campaign-summay-item">
        <img src="/assets/img/icons/svgs/TotalSuccessFee.svg" alt="Total Success Fee" />
        <div class="campaign-summay-item-badge">
          <div class="campaign-summay-item-title">Total Success Fee (incl. SST)</div>
          <div class="campaign-summay-item-value">
            {{ campaignSummary.successFee ? (campaignSummary.successFee | numberSuffix) : '-' }}
          </div>
          @if (IsShowSubTitle()) {
            <div class="campaign-summay-item-subtitle">Available at Allotment Stage</div>
          }
        </div>
      </div>
    </div>
    @if (campaign.isCreator) {
      <div class="content-container">
        <app-investor-management-list
          [campaign]="campaign"
          [finalSubmitted]="finalSubmitted"
          (reviewStatusUpdated)="getcampaignSummary()"
        ></app-investor-management-list>
      </div>
    } @else {
      <div class="alert alert-warning tw-my-4">
        You do not have permission to view this campaign's investor list.
      </div>
    }
  } @else {
    @if (isPageLoading) {
      <div class="tw-py-10 tw-text-center">Loading campaign...</div>
    }
    @if (!isPageLoading && loadError) {
      <div class="alert alert-warning tw-my-4">
        Unable to load campaign data. Please return to Campaign Management and try again.
      </div>
    }
  }
</div>
